import script from "./PsaAcceptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PsaAcceptModal.vue?vue&type=script&setup=true&lang=js"

import "./PsaAcceptModal.vue?vue&type=style&index=0&id=d89f9146&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d89f9146"]])

export default __exports__